var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-slide-list',{attrs:{"items":_vm.value,"sort-by":"price","width":"170"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('fragment-box',{key:item._id,attrs:{"balance":_vm.fragmentBoxesBalance ? _vm.fragmentBoxesBalance[item.fragmentId] : 0,"value":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }